const menuButton = document.getElementById("menuButton");
const menuContactWrap = document.getElementById("js-menu_layer");
const menuHeader = document.querySelector(".js-header, #header");
const spMediaQuery = window.matchMedia("(max-width: 768px)");
let isMenuOpened = false;

if (menuButton && menuContactWrap) {
  menuButton.setAttribute("aria-expanded", "false");
  menuContactWrap.setAttribute("aria-hidden", spMediaQuery.matches ? "true" : "false");
}

function openMenu() {
  isMenuOpened = true;
  menuButton.classList.add("is-opened");
  menuButton.setAttribute("aria-expanded", "true");
  menuContactWrap.classList.add("is-opened");
  menuContactWrap.setAttribute("aria-hidden", "false");
  if (menuHeader) {
    menuHeader.classList.add("is-opened");
  }
}

function closeMenu() {
  isMenuOpened = false;
  menuButton.classList.remove("is-opened");
  menuButton.setAttribute("aria-expanded", "false");
  menuContactWrap.classList.remove("is-opened");
  menuContactWrap.setAttribute("aria-hidden", spMediaQuery.matches ? "true" : "false");
  if (menuHeader) {
    menuHeader.classList.remove("is-opened");
  }
}

function toggleMenu() {
  if (!isMenuOpened) {
    openMenu();
  } else {
    closeMenu();
  }
}

if (menuButton && menuContactWrap) {
  menuButton.addEventListener("click", toggleMenu);
}

spMediaQuery.addEventListener("change", (event) => {
  if (!event.matches && isMenuOpened) {
    closeMenu();
    return;
  }

  if (menuContactWrap && !isMenuOpened) {
    menuContactWrap.setAttribute("aria-hidden", event.matches ? "true" : "false");
  }
});
